"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var TywLogo = function TywLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 413.27",
    style: {
      enableBackground: "new 0 0 1920 413.27}}"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || 'Yacht Week Logo'), /*#__PURE__*/_react["default"].createElement("g", {
    fill: fill
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "244.98,146.65 205.31,202.54 203.75,202.54 163.89,146.65 135.56,146.65 191.83,222.47 191.83,278.74 215.28,278.74 215.28,222.47 271.16,146.65 \t\t"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M365.95,244.69c-17.36-8.82-36.52-13.04-61.71-14.08l26.85-60.11h1.56l27.94,62.13L365.95,244.69z M318.38,146.65l-60.77,132.09h25.01l11.14-25.01l1.74-3.84c44.68,0.61,64.19,10.3,85.77,28.79l0,0l0.03,0.06h25.99l-60.57-132.09 H318.38z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M487.48,259c-30.87,0-49.04-19.34-49.04-46.5c0-26.77,18.17-46.11,47.48-46.11c20.32,0,33.8,7.62,42.98,23.05 l18.95-12.11c-11.33-21.3-33.02-33.02-61.94-33.02c-42.4,0-71.51,29.31-71.51,68.19c0,39.27,29.11,68.58,73.07,68.58 c28.14,0,51-13.68,62.33-34.78l-17.78-11.53C524.02,249.82,507.8,259,487.48,259"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "680.11,194.72 601.37,194.72 601.37,146.65 577.92,146.65 577.92,278.74 601.37,278.74 601.37,216.41 680.11,216.41 680.11,278.74 703.75,278.74 703.75,146.65 680.11,146.65 \t\t"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "727.77,146.65 727.77,168.15 781.9,168.15 781.9,278.74 805.54,278.74 805.54,168.15 859.27,168.15 859.27,146.65 \t\t"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "1322.9,146.7 1287.73,251.23 1286.17,251.23 1251,146.7 1225.01,146.7 1189.25,251.04 1187.89,251.04 1153.3,146.7 1127.12,146.7 1174.01,278.78 1202.15,278.78 1236.73,183.43 1238.29,183.43 1272.29,278.78 1300.43,278.78 1347.52,146.7 \t\t"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "1366.58,146.7 1366.58,278.78 1476.59,278.78 1476.59,257.29 1390.03,257.29 1390.03,216.45 1467.6,216.45 1467.6,194.96 1390.03,194.96 1390.03,168.39 1474.63,168.39 1474.63,146.7 \t\t"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: fill,
    points: "1505.55,146.7 1505.55,278.78 1615.55,278.78 1615.55,257.29 1528.99,257.29 1528.99,216.45 1606.57,216.45 1606.57,194.96 1528.99,194.96 1528.99,168.39 1613.6,168.39 1613.6,146.7 \t\t"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1781.58,278.78l-57.1-85.44c19.46-14.13,33.15-31.85,41.38-46.74h-26.69 c-19.22,29.97-44.18,42.18-71.31,47.7v-47.6h-23.45v132.09h23.45V231.5v-14.66c13.59-2.14,25.82-6.23,36.75-11.56l49.03,73.5 H1781.58z"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M958.31,297.47l-44.83-25.73c-4.72,5.06-9.72,10.03-15.02,14.88l41.07,23.89 C946.17,306.41,952.41,302.04,958.31,297.47z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1021.96,196.52c2.64-15.17,2.99-30.74,0.83-44.01l-42.42-24.42c-2.76,19.42-7.37,38.81-14.29,57.77l51,29.42 c-2.42,7.74-5.46,15.31-9.13,22.67l-51.32-29.55c-5.91,12.42-12.94,24.58-21.23,36.34l49.05,28.3c6.35-7.21,11.95-14.76,16.8-22.6 l42.25,24.34c6.29-8.67,11.82-18.51,16.26-29.7c3.08-7.76,5.21-15.4,6.54-22.88L1021.96,196.52z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M958.31,297.47l34.49,19.79c10.83-5.51,21.53-12.46,31.4-21.21l-39.74-23.01 C984.45,273.04,969.59,288.57,958.31,297.47z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1065.04,176.84c-12.63-55.26-61.57-95.28-71.85-103.18l-1.54-0.89c17.78,25.96,27.97,53.06,31.14,79.74 L1065.04,176.84z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M907.14,327.22l17.27,9.91c11.81-1.35,27.45-4.13,44.12-9.74l-29.01-16.88 C929.53,316.69,916.1,323.64,907.14,327.22z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M854.31,319.9l28.55,16.43c8.46-2.74,16.55-5.79,24.29-9.11l-34.37-19.72 C866.91,311.76,860.75,315.89,854.31,319.9z"
  }))));
};
TywLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
TywLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = TywLogo;